<template>

    <v-modal
        :open="open"
        class="c-modal_confirm_visit">
        <h2>Rozpoczynanie wizyty</h2>
        <p class="c-modal_confirm_visit__content">Ta wizyta została zaplonowana na dzień <strong>{{
                event.date
            }}</strong></p>
        <p class="c-modal_confirm_visit__question">Czy na pewno chcesz ją teraz rozpocząć? </p>
        <form-row align="between">
            <v-btn
                type="green"
                @click="ok">
                Tak, rozpocznij
            </v-btn>
            <v-btn
                type="white"
                @click="cancel">
                Nie
            </v-btn>
        </form-row>
    </v-modal>

</template>


<script>

import VModal from 'Components/VModal'
import {FormRow} from 'Components/Form'
import VBtn from 'Components/VBtn'
import moment from 'moment'

export default {

    name: 'VisitConfirmModal',

    data() {
        return {
            event: {},
            open: false
        }
    },

    methods: {
        cancel() {
            this.open = false
            this.$emit('cancel')
        },
        ok() {
            this.open = false
            this.$emit('ok')
        }
    },

    mounted() {
        this.$on('open', (event) => {
            this.event = event
            this.open = true
        })
    },

    beforeDestroy() {
        this.$off('open')
    },

    components: {
        FormRow,
        VModal,
        VBtn
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-modal_confirm_visit {
    text-align: center;

    &__content {
        margin: 1.5rem 0;
    }
    &__question {
        color: $c-primary;
        font-weight: 800;
        margin-bottom: 2rem;
    }
    button {
        margin: .5rem;
    }
}

</style>
